import { Caption as e } from "../../Typography/Typography.mjs";
import { Icons as t } from "../Icons/Icons.mjs";
import { Button as n } from "../Button/Button.mjs";
import { Modal as r, ModalBody as i, ModalClose as a, ModalContent as o, ModalFooter as s, ModalHeader as c, ModalTitle as l } from "../Modal/Modal.mjs";
import { getCroppedImg as u } from "./hooks/getCroppedImg.mjs";
import { CropStage as d, ZoomRow as f, ZoomSlider as p } from "./styled/ImageCropper.styled.mjs";
import { useCallback as m, useState as h } from "react";
import { useTranslation as g } from "@maat/store-i18n";
import { jsx as _, jsxs as v } from "react/jsx-runtime";
import y from "react-easy-crop";
import "react-easy-crop/react-easy-crop.css";
//#region src/components/ImageCropper/ImageCropper.tsx
var b = ({ open: b, onOpenChange: x, src: S, aspect: C = 16 / 9, onCropped: w, isSaving: T = !1, title: E, outputMaxWidth: D = 1600, mimeType: O = "image/webp", fileName: k = "cropped.webp" }) => {
	let { t: A } = g("ds"), [j, M] = h({
		x: 0,
		y: 0
	}), [N, P] = h(1), [F, I] = h(null), [L, R] = h(!1), z = m((e, t) => I(t), []), B = async () => {
		if (F) {
			R(!0);
			try {
				await w(await u(S, F, {
					maxWidth: D,
					mimeType: O,
					fileName: k
				}));
			} finally {
				R(!1);
			}
		}
	}, V = L || T;
	return /* @__PURE__ */ _(r, {
		open: b,
		onOpenChange: x,
		children: /* @__PURE__ */ v(o, {
			size: "lg",
			closeOnOverlayClick: !V,
			children: [
				/* @__PURE__ */ v(c, { children: [/* @__PURE__ */ _(l, { children: E ?? A("ds:imageCropper.title") }), /* @__PURE__ */ _(a, { "aria-label": A("common:actions.close") })] }),
				/* @__PURE__ */ v(i, { children: [
					/* @__PURE__ */ _(d, { children: S && /* @__PURE__ */ _(y, {
						image: S,
						crop: j,
						zoom: N,
						aspect: C,
						onCropChange: M,
						onZoomChange: P,
						onCropComplete: z,
						showGrid: !0
					}) }),
					/* @__PURE__ */ v(f, { children: [
						/* @__PURE__ */ _(t.ZoomOut, { size: 16 }),
						/* @__PURE__ */ _(p, {
							type: "range",
							min: 1,
							max: 3,
							step: .01,
							value: N,
							onChange: (e) => P(Number(e.target.value)),
							"aria-label": A("ds:imageCropper.zoom")
						}),
						/* @__PURE__ */ _(t.ZoomIn, { size: 16 })
					] }),
					/* @__PURE__ */ _(e, { children: A("ds:imageCropper.caption") })
				] }),
				/* @__PURE__ */ v(s, { children: [/* @__PURE__ */ _(n, {
					type: "button",
					variant: "outline",
					onClick: () => x(!1),
					disabled: V,
					children: A("common:actions.cancel")
				}), /* @__PURE__ */ _(n, {
					type: "button",
					variant: "primary",
					rounded: !0,
					onClick: B,
					isLoading: V,
					disabled: !F,
					children: A("common:actions.save")
				})] })
			]
		})
	});
};
//#endregion
export { b as ImageCropper };
